import { Link } from "react-router-dom";
import { useI18n } from "i18n";
import { PAGES, usePageTracking } from "modules/tracking";
import { RemoLogo } from "@remo-co/ui-core/src/components/RemoLogo";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { Button } from "@remo-co/ui-core/src/components/Button";
import { Box } from "@remo-co/ui-core/src/components/Box";
import { styles } from "./styles";

export const PageNotFound = () => {
  const { t } = useI18n(["common", "errorPage"]);

  usePageTracking(PAGES.PAGE_NOT_FOUND);

  return (
    <Box sx={styles.container}>
      <Box component="a" href="/" sx={styles.logoContainer}>
        <RemoLogo width={225} />
      </Box>
      <Typography variant="h2">{t("errorPage:404.does.not.exist")}</Typography>
      <Typography variant="body1" sx={styles.bodyText}>
        {t("errorPage:404.sorry")}
        <br />
        {t("errorPage:404.existed")}
      </Typography>

      <Link to="/my-events" style={styles.link}>
        <Button variant="primary" color="blue" sx={styles.button}>
          {t("errorPage:back.dashboard")}
        </Button>
      </Link>
    </Box>
  );
};
